import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class SalesService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('sales/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('sales/list', val_params);
  }

  previewDataForm(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('sales/form/preview', val_params);
  }

  get(val_id: number) {
    return this.restService.get('sales/edit', val_id);
  }

  detail(val_id: number) {
    return this.restService.get('sales/detail', val_id);
  }

  save(data: any) {
    return this.restService.save('sales/save', data);
  }

  saveHotelBooking(data: any) {
    return this.restService.save('sales/save/hotelbooking', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('sales/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('sales/delete', val_id);
  }
}
